import Box from "@mui/material/Box";
import type { ITextFieldStyles } from "@fluentui/react/lib/TextField";
import * as React from "react";
import type { FtlPanelFormData } from "./ftlFormModel";
import { FtlShipmentWeightEquipmentFields } from "./FtlShipmentWeightEquipmentFields";
import { FtlShipmentZipsDateFields } from "./FtlShipmentZipsDateFields";
import { styles } from "./FTL.styles";

export function FtlShipmentDetailsGrid({
  formData,
  errors,
  weightWarning,
  equipmentOptions,
  onInputChange,
  onPersistBlur,
  getTextFieldStyles,
  onSelectEquipment,
}: {
  formData: FtlPanelFormData;
  errors: Record<string, string>;
  weightWarning?: string;
  equipmentOptions: string[];
  onInputChange: (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => void;
  onPersistBlur: () => void;
  getTextFieldStyles: (fieldName: string) => Partial<ITextFieldStyles>;
  onSelectEquipment: (equipment: string) => void;
}): React.ReactElement {
  return (
    <Box className="shipment-details-grid" sx={styles.grid}>
      <FtlShipmentZipsDateFields
        formData={formData}
        errors={errors}
        onInputChange={onInputChange}
        onPersistBlur={onPersistBlur}
        getTextFieldStyles={getTextFieldStyles}
      />
      <FtlShipmentWeightEquipmentFields
        formData={formData}
        errors={errors}
        weightWarning={weightWarning}
        equipmentOptions={equipmentOptions}
        onInputChange={onInputChange}
        onPersistBlur={onPersistBlur}
        getTextFieldStyles={getTextFieldStyles}
        onSelectEquipment={onSelectEquipment}
      />
    </Box>
  );
}
